import Label from "../../../components/label/label";
import Input from "../../../components/input/input";
import Button from "../../../components/button/button";
import { Link } from 'react-router-dom';

function ObPartner({ onNext, onBack, formData, onUpdateData }) {
    const partners = formData.partners || [];

    const handleNextClick = () => {
        onNext(formData);
    };

    const handleBackClick = () => {
        onBack();
    };

    const addPartner = () => {
        const newPartners = [...partners, { prename: '', name: '' }];
        onUpdateData({ partners: newPartners });
    };

    const handlePartnerChange = (index, field, value) => {
        const updatedPartners = partners.map((partner, i) => {
            if (i === index) {
                return { ...partner, [field]: value };
            }
            return partner;
        });
        onUpdateData({ partners: updatedPartners });
    };

    const removePartner = (index) => {
        const filteredPartners = partners.filter((_, i) => i !== index);
        onUpdateData({ partners: filteredPartners });
    };

    return (
        <div>
            <h2>Möchtest du deinem Geschäft Partner hinzufügen?</h2>
            
            <div>
                {partners.map((partner, index) => (
                    <div key={index}>
                        <h4>Partner {index + 1}</h4>
                        <Label labelValue="Vorname:" />
                        <Input
                            inputType="text"
                            inputValue={partner.prename}
                            onChange={(e) => handlePartnerChange(index, 'prename', e.target.value)}
                            borderColor="black"
                        /><br/>
                        <Label labelValue="Nachname:" />
                        <Input
                            inputType="text"
                            inputValue={partner.name}
                            onChange={(e) => handlePartnerChange(index, 'name', e.target.value)}
                            borderColor="black"
                        /><br/>
                        <button type="button" onClick={() => removePartner(index)} style={{color: 'red', marginTop: '5px', cursor: 'pointer'}}>
                            Entfernen
                        </button>
                    </div>
                ))}
                
                <Button 
                    onClick={addPartner}
                    buttonValue="+ Partner hinzufügen"
                />
            </div>

            <div className="linkContainer">
                <Link onClick={handleBackClick}>Zurück</Link>
                <Link onClick={handleNextClick}>Weiter</Link>
            </div>
        </div>
    );
}

export default ObPartner;